function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { SUPPORTED_LOGOS_NUMBER_OPTIONS } from "segments/desktop/core-components/logos/logos-const";
import classNames from "classnames";
import { withGenericConfig } from "contexts/generic-config-context";
import DefaultProps from "./default-props";
import ImagesGalleryComponent from "/components/core/images-gallery/images-gallery-component";
import { getCompaniesAssets, NUMBER_OF_COMPANIES } from "./logos-const";
import { MOBILE_QUERY } from "/constants/vp-sizes";
import { withAbTests } from "contexts/ab-tests-context";
import { StyledLogos } from "./logos.scss";
class Logos extends PureComponent {
    componentDidMount() {
        if (window.matchMedia(MOBILE_QUERY).matches) {
            this.setState({
                mobileView: true
            });
        }
    }
    render() {
        const { grayscale, showAllLogos, companyField, country, slim, personalizeUsingVisitorCountry, cloudfrontViewerCountry, abTests, logosScale, useSingleLine, paddingInlined, maxWidth } = this.props;
        const assets = getCompaniesAssets({
            companyField,
            country,
            personalizeUsingVisitorCountry,
            cloudfrontViewerCountry,
            abTests
        });
        const numberOfCompaniesToDisplay = this.getNumberOfCompaniesToDisplay();
        const companiesAssetsSliced = showAllLogos ? assets : assets.slice(0, numberOfCompaniesToDisplay);
        return /*#__PURE__*/ _jsx(StyledLogos, {
            className: classNames("logos", {
                "full-logo-list": showAllLogos,
                "new-layout": this.isNewLayout(),
                slim
            }),
            logosScale: logosScale,
            useSingleLine: useSingleLine,
            paddingInlined: paddingInlined,
            maxWidth: maxWidth,
            children: /*#__PURE__*/ _jsx("div", {
                className: "images-logos-wrapper",
                children: /*#__PURE__*/ _jsx(ImagesGalleryComponent, {
                    grayscale: grayscale,
                    assets: companiesAssetsSliced,
                    shouldTrackMouseEvents: true
                })
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "isNewLayout", ()=>{
            return this.getNumberOfCompaniesToDisplay() == NUMBER_OF_COMPANIES; // compare string and int (old props can be integers)
        });
        _define_property(this, "getNumberOfCompaniesToDisplay", ()=>{
            const { numberOfCompanies } = this.props;
            if (SUPPORTED_LOGOS_NUMBER_OPTIONS.includes(numberOfCompanies === null || numberOfCompanies === void 0 ? void 0 : numberOfCompanies.toString())) return numberOfCompanies;
            return NUMBER_OF_COMPANIES; // support old pages config which had companyNummber = 3, 8  + use this as the default prop when numberOfCompanies isn't defined
        });
        this.state = {
            mobileView: false
        };
    }
}
Logos.defaultProps = DefaultProps;
export default withAbTests(withGenericConfig(Logos));
